import {z} from '@hono/zod-openapi';

import {nissanDiglasInvoiceSchema} from './nissanDiglasInvoiceSchema';

export const nissanDiglasStructuredSourceSchema = z
  .object({
    format: z.literal('NISSAN_DIGLAS'),
    documentType: z.literal('INVOICE'),
    supplierName: z.string(),
    supplierTaxId: z.string(),
    customerName: z.string(),
    customerTaxId: z.string(),
    vatExemptionCode: z.string().nullable(),
    completenessIndicator: z.boolean(),
    sourcePaymentDate: z.string().date().nullable(),
    invoice: nissanDiglasInvoiceSchema,
  })
  .openapi('NissanDiglasStructuredSource');
